import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import useConfirmDialogStyles from '../../../styles/useConfirmDialogStyles';

export interface IConfirmDialog {
  isOpen: boolean;
  title: string;
  content: string;
  onConfirm?: () => void;
}

interface DialogProps {
  confirmDialog: IConfirmDialog;
  setConfirmDialog: Dispatch<SetStateAction<IConfirmDialog>>;
}

function ConfirmDialog(props: DialogProps) {
  const { confirmDialog, setConfirmDialog } = props;
  const classes = useConfirmDialogStyles();

  const onClose = () => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
  };

  return (
    <Dialog disableRestoreFocus={true} open={confirmDialog.isOpen} onClose={onClose}>
      <DialogTitle className={classes.dialogTitle}>Confirm the action</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography variant="body1">{confirmDialog.title}</Typography>
        <Typography variant="subtitle2">
          <b>{confirmDialog.content}</b>
        </Typography>
      </DialogContent>
      <DialogActions className={classes.dialogAction}>
        <Button variant="contained" size="large" className={classes.deleteButton} onClick={confirmDialog.onConfirm}>
          Delete
        </Button>

        <Button
          variant="outlined"
          size="large"
          color="neutral"
          onClick={() =>
            setConfirmDialog({
              ...confirmDialog,
              isOpen: false,
            })
          }
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDialog;
